import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { AuditModel } from '../models/login/audit.model';
import { AddUserModel, UpdateUserModel } from '../models/user/addUser.model';
import { ChangeUserPasswordModel } from '../models/user/changeUserPassword.model';
import { UserListingModel } from '../models/user/userListing.model';
import { ApiService } from './Common/api.service';
import { UrlHelperService } from './Common/urlhelper.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private _api:ApiService) { }
  
  audit(audit: AuditModel)
  {
    return this._api.post(UrlHelperService.audit, audit);
  }

  userlist()
  {
    return this._api.post(UrlHelperService.userlist);
  }

  userlisting(userListing: UserListingModel)
  {    
    return this._api.post(UrlHelperService.userlisting, userListing);    
  }

  userRoles()
  {
    return this._api.post(UrlHelperService.userRoles);
  }

  addUser(addUser: AddUserModel)
  {    
    return this._api.post(UrlHelperService.addUser, addUser);    
  }

  getuserbyid(id){
    return this._api.post(UrlHelperService.getuserbyid+id);
  }

  getUserId = new BehaviorSubject(<string>'');
  passUserId(userId){
    this.getUserId.next(userId);
  }
  
  updateUserPassword(userDetail: ChangeUserPasswordModel){
    return this._api.post(UrlHelperService.updateUserPassword+userDetail.Id, userDetail);
  }
  
  updateUserDetail(updateUserDetail: UpdateUserModel){
    return this._api.post(UrlHelperService.updateUserDetails, updateUserDetail);
  }
}
